// Usage Tracker for Kazang BackOffice
// Tracks page views and button clicks via SynergyApi batch endpoint

const USAGE_BASE_URL = 'https://lna.pos.co.zm/SynergyApi/api/v1/usage/record';
const APP_KEY = 'kazang-backoffice-1780472570854';

let eventQueue = [];
let flushTimer = null;
const FLUSH_INTERVAL = 5000; // flush every 5 seconds
const BATCH_SIZE = 20;

function getDeviceId() {
    let id = localStorage.getItem('chrilan_device_id');
    if (!id) {
        id = 'dev_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
        localStorage.setItem('chrilan_device_id', id);
    }
    return id;
}

function getUserId() {
    return window.userId || null;
}

function enqueue(event) {
    eventQueue.push({
        app_key: APP_KEY,
        user_id: getUserId(),
        device_id: getDeviceId(),
        feature: event.feature,
        action: event.action,
        customer_id: event.customerId || null,
        store_id: event.storeId || null,
        business_type: event.businessType || null,
        timestamp: new Date().toISOString()
    });

    if (eventQueue.length >= BATCH_SIZE) {
        flush();
    } else if (!flushTimer) {
        flushTimer = setTimeout(flush, FLUSH_INTERVAL);
    }
}

async function flush() {
    if (!flushTimer) clearTimeout(flushTimer);
    flushTimer = null;

    if (eventQueue.length === 0) return;

    const batch = eventQueue.splice(0);
    if (batch.length === 0) return;

    try {
        const response = await fetch(`${USAGE_BASE_URL}/batch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(batch)
        });
        if (!response.ok) {
            // Put events back on failure
            eventQueue.unshift(...batch);
        }
    } catch (err) {
        // Re-queue on network failure
        eventQueue.unshift(...batch);
    }
}

// Public API
window.usageTracker = {
    track(feature, action = 'view', extras = {}) {
        enqueue({ feature, action, ...extras });
    },

    trackPageView(pageName) {
        this.track(`page:${pageName}`, 'view');
    },

    trackClick(btnName) {
        this.track(`btn:${btnName}`, 'click');
    },

    trackFormSubmit(formName) {
        this.track(`form:${formName}`, 'submit');
    },

    trackError(feature, errorMsg) {
        this.track(`error:${feature}`, 'error', { description: errorMsg });
    },

    // Flush immediately (e.g., on logout)
    flushNow() {
        flush();
    }
};

// Auto-flush before page unload
window.addEventListener('beforeunload', () => flush());